import { render, staticRenderFns } from "./TopicSubsection.vue?vue&type=template&id=7f11cbcd&scoped=true"
import script from "./TopicSubsection.vue?vue&type=script&lang=js"
export * from "./TopicSubsection.vue?vue&type=script&lang=js"
import style0 from "./TopicSubsection.vue?vue&type=style&index=0&id=7f11cbcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f11cbcd",
  null
  
)

export default component.exports